import { ClientException } from "@/types/client-exceptions"
import { FlightItineraryApi } from "@/types/flights/flight-itinerary-api"

export interface FlightOfferUnavailableData {
  flight_itinerary: FlightItineraryApi
}

function isFlightOfferUnavailableData(
  data: unknown
): data is FlightOfferUnavailableData {
  if (!data || typeof data !== "object") return false
  if (!("flight_itinerary" in data)) return false
  return !!data.flight_itinerary
}

export class FlightDateOutOfRangeException extends ClientException<
  never,
  "FlightDateOutOfRangeException"
> {
  constructor(message: string, options?: ErrorOptions) {
    super("FlightDateOutOfRangeException", message, undefined, options)
  }
}

export class FlightSeatMapUnavailableException extends ClientException<
  never,
  "FlightSeatMapUnavailableException"
> {
  constructor(message: string, options?: ErrorOptions) {
    super("FlightSeatMapUnavailableException", message, undefined, options)
  }
}

// An NDC fare is priced for the traveler set it was shopped with, so changing the passenger
// count invalidates it and the customer restarts from search with the counts they asked for.
export interface FlightPassengersChangedData {
  passengers: {
    adults?: number
    children?: number
    infants_in_seat?: number
    infants_on_lap?: number
  }
}

function isFlightPassengersChangedData(
  data: unknown
): data is FlightPassengersChangedData {
  if (!data || typeof data !== "object") return false
  if (!("passengers" in data)) return false
  return !!data.passengers && typeof data.passengers === "object"
}

export class FlightPassengersChangedException extends ClientException<
  FlightPassengersChangedData | undefined,
  "FlightPassengersChangedException"
> {
  constructor(message: string, data?: unknown, options?: ErrorOptions) {
    super(
      "FlightPassengersChangedException",
      message,
      isFlightPassengersChangedData(data) ? data : undefined,
      options
    )
  }
}

export class FlightExpirationException extends ClientException<
  never,
  "FlightExpirationException"
> {
  constructor(message: string, options?: ErrorOptions) {
    super("FlightExpirationException", message, undefined, options)
  }
}

export class FlightOfferUnavailableException extends ClientException<
  FlightOfferUnavailableData | undefined,
  "FlightOfferUnavailableException"
> {
  constructor(message: string, data?: unknown, options?: ErrorOptions) {
    super(
      "FlightOfferUnavailableException",
      message,
      isFlightOfferUnavailableData(data) ? data : undefined,
      options
    )
  }
}

export class FlightUnableToPriceException extends ClientException<
  never,
  "FlightUnableToPriceException"
> {
  constructor(message: string, options?: ErrorOptions) {
    super("FlightUnableToPriceException", message, undefined, options)
  }
}

export class FlightUnableToCheckoutException extends ClientException<
  never,
  "FlightUnableToCheckoutException"
> {
  constructor(message: string, options?: ErrorOptions) {
    super("FlightUnableToCheckoutException", message, undefined, options)
  }
}
